import { render, staticRenderFns } from "./SucessoAtendimentoHibrido.vue?vue&type=template&id=4cfe3660&scoped=true&"
import script from "./SucessoAtendimentoHibrido.vue?vue&type=script&lang=js&"
export * from "./SucessoAtendimentoHibrido.vue?vue&type=script&lang=js&"
import style0 from "./SucessoAtendimentoHibrido.vue?vue&type=style&index=0&id=4cfe3660&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4cfe3660",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBtn,VContainer,VIcon,VRow})
